// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicTicketFareStateControllerGetAllData } from './PublicTicketFareStateControllerGetAllData.gen';
import type { PublicTicketFareStateControllerGetAllErrors } from './PublicTicketFareStateControllerGetAllErrors.gen';
import type { PublicTicketFareStateControllerGetAllResponses } from './PublicTicketFareStateControllerGetAllResponses.gen';

export class PublicTicketFareStateController {
    /**
     * Get ticket fare state
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicTicketFareStateControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicTicketFareStateControllerGetAllResponses, PublicTicketFareStateControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/ticket-fare-states',
            ...options
        });
    }
}
